import React from 'react'
import { Box, Theme } from '@mui/material'

interface CheckboxProps {
  checked: boolean
  onChange: (e: React.MouseEvent) => void
  disabled?: boolean
  indeterminate?: boolean
  size?: number
  sx?: SxProps
}

interface SxProps {
  borderColor?: string
  backgroundColor?: string
  color?: string
}
const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  disabled,
  indeterminate,
  size = 16,
  sx = {}
}) => {
  const strokeWidth = 1
  const rectSize = size - strokeWidth
  const offset = strokeWidth / 2
  const checkStroke = size <= 16 ? 1.5 : 2
  return (
    <Box
      onClick={disabled ? undefined : onChange}
      sx={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'default' : 'pointer',
        position: 'relative',
        backgroundColor: disabled ? '#F9FAFB' : 'transparent'
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        shapeRendering="crispEdges"
      >
        <rect
          x={offset}
          y={offset}
          width={rectSize}
          height={rectSize}
          rx="4"
          fill={checked || indeterminate ? sx?.backgroundColor || "#EBF2FE" : (disabled ? "#F3F4F6" : "white")}
          stroke={sx?.borderColor || '#DBE8FE'}
          strokeWidth={strokeWidth}
        />
        {checked || indeterminate ? (
          indeterminate ? (
            <path
              d={`M${size * 0.3} ${size / 2}H${size * 0.7}`}
              stroke={sx?.color || '#3B82F6'}
              strokeWidth={checkStroke}
              strokeLinecap="round"
            />
          ) : (
            <path
              d={`M${size * 0.7} ${size * 0.33}L${size * 0.44} ${size * 0.6}L${size * 0.3} ${size * 0.46}`}
              stroke={sx?.color || '#3B82F6'}
              strokeWidth={checkStroke}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          )
        ) : null}
      </svg>
    </Box>
  )
}

export default Checkbox